import { postApi } from 'api/fetchApi'
import { operations } from 'api/generated/messenger_reactions'

type Operation = operations['messenger_read_reaction_to_messages_readReactions']
type Response = Operation['responses']['204']
type Body = Operation['parameters']['body']['body']

export const readReactionApi = (messageUuid: string) => {
  return postApi<Response, Body>('/messages/reactions/read', {
    messagesIds: [messageUuid],
  })
}
